import { Proposal } from 'entities/Proposal/model/types/ProposalSchema';
import { Vendor, VendorActivationStatus } from 'entities/Vendors';

export interface OrderItemDeadEndSource {
    isCheckFinished?: boolean;
    proposals?: Proposal[];
}

const isProposalOrderable = (
    proposal: Proposal,
    vendorsMap: Record<string, Vendor>,
): boolean => {
    const vendor = vendorsMap[proposal.seller?.uid];
    if (vendor?.operationsAccountStatus !== VendorActivationStatus.VERIFIED) {
        return false;
    }

    return (proposal.availableQuantity ?? 0) > 0;
};

/**
 * An order line is a dead end when the user cannot fulfill any quantity:
 * no suppliers, no enabled supplier, every supplier is out of stock, or
 * every supplier is pending / action required.
 */
export const isOrderItemDeadEnd = (
    item: OrderItemDeadEndSource,
    vendorsMap: Record<string, Vendor> | null | undefined,
    isPreSubmission: boolean,
): boolean => {
    if (!isPreSubmission || !item.isCheckFinished) {
        return false;
    }

    const proposals = item.proposals ?? [];
    if (proposals.length === 0) {
        return true;
    }

    if (!vendorsMap) {
        return false;
    }

    return !proposals.some((proposal) =>
        isProposalOrderable(proposal, vendorsMap),
    );
};
